export const about = {
  name: "Hari Tummala",
  email: "hari.tummala88@gmail.com",
  title: "Full Stack Software Engineer",
  dateOfBirth: "28 August 1994",
  from: "Machilipatnam, India",
  currentLocation: "Berlin, Germany",
  details:
    'I am an experienced "Full Stack Software Engineer" with a strong working knowledge in all the phases of SDLC. I love to develop lightweight user interfaces and enjoys creating scalable backends using Microservices architecture by following best DevOps/NoOps practices.',
};

export const education = [
  {
    institution: "K L University",
    url: "https://www.kluniversity.in/",
    degree: "Bachelor of Technology in Electrical and Electronics Engineering",
    details: [
      "Learned all core and advanced topics in Electrical Engineering and also gained knowledge in SQL, C, java and web technologies in parallel with the curriculum.",
      "My interest in mathematical modelling earned me a specialization in power systems.",
      "Courses like Problem Solving through Programming, Database Managment Systems and Micro processors and Micro controllers increased my passion towards software engineering.",
      "Graduated from university with two best paper presentation awards, two paper publications, a poster presentation award and one job offer from Cognizant"
    ],
    location: "Vijayawada, India",
    duration: "2011 - 2015"
  },
  {
    institution: "RK Junior College",
    url: "http://www.rkedu.org/",
    degree: "Intermediate in MPC (Maths/Physics & Chemistry)",
    details: [
      "This is the place where I improved my problem solving skills and increased my passion towards engineering.",
    ],
    location: "Machilipatnam, India",
    duration: "2009 - 2011"
  }
]

export const experience = [
  {
    company: "ELEMENT Insurance AG",
    designation: "Senior Full-Stack Engineer",
    url: "https://www.element.in/",
    details: [
      "Creating an Insurance as a Service Product with industry standard processes and tools.",
      "Implementing scalable backend microservices to manage the lifecycle of a policy, including customer creation, policy creation and updation, renewals and document generation.",
      "Developing a web portal to the partners to search for the customers and to view individual customer policies and payment details.",
      "Creating a web application for the internal operations team to view and update a policy.",
      "Implementing all the UI using micro-frontends architecture.",
      "Creating end to end UI and API tests.",
    ],
    techStack: "Java, Spring Ecosystem, Postgresql, Type Script, React.js, Ant Design, Cypress, Github Actions, Terraform and AWS (SQS, SNS, Lambda, DynamoDB, Fargate, XRay).",
    location: "Berlin, Germany",
    duration: "Jun 2021 - Present"
  },
  {
    company: "Friday Insurance",
    designation: "Software Engineer",
    url: "https://www.friday.de/",
    details: [
      "Rethinking insurance together with product managers, designers and domain experts.",
      "Automating policy creation processes for car insurance.",
      "Driven the development of several features, including Pay-per-km tariff, Cancellations, Registration, Renewals and Add-on Purchasing.",
      "Providing self-service features to the insurance holders.",
      "Developed an in-memory price calculation service inorder to support the high incoming traffic from brokers.",
    ],
    techStack: "Kotlin, Java, Spring Ecosystem, Micronaut, Postgresql, Kubernetes, React.js and Guidewire Policycenter.",
    location: "Berlin, Germany",
    duration: "Apr 2020 - May 2021"
  },
  {
    company: "AUTO1 Group",
    designation: "Software Engineer",
    url: "https://www.auto1.com/",
    details: [
      "Responsible for developing and maintaining a system of 16 company's backend microservices.",
      "Automated internal employees lifecycle processes: Onboarding, Offboarding, Probation end and 360 feedbacks.",
      "Implemented a currency converter service, which stores daily currency rates from the European Central Bank. This service is being used by all the other teams to fetch the currency conversions.",
      "Involved in developing a vehicle search service which utilises all the powerful features that elastic search has to offer.",
      "Developed several E2E api tests to maintain the quality of delivered software "
    ],
    location: "Berlin, Germany",
    duration: "Aug 2018 - Mar 2020",
    techStack: "Java 11, Spring Ecosystem, Elastic Search, Postgresql, Cucumber, Rest Assured, Jenkins, Terraform and AWS (ECS, SQS)."
  },
  {
    company: "Verizon",
    designation: "Software Engineer",
    url: "https://www.verizon.com/",
    details: [
      "Rewritten Verizon Wireless point of sale (POS) monolithic application using microservice architecture.",
      "Added many functionalities to the legacy POS applications which are written in ATG Web Commerce Framework.",
      "Created light weight and responsive web user interfaces to make life of operations easier."
    ],
    location: "Chennai, India",
    duration: "Jul 2017 - Aug 2018",
    techStack: "Java 8, Spring Boot, Angular 4, RabbitMQ and AWS."
  },
  {
    company: "Cognizant",
    designation: "Programmer Analyst",
    url: "https://www.cognizant.com/",
    details: [
      "Played a crucial role in developing a data mining and analysis tool to help risk managers with information about their policies and claims.",
      "Ported and extended a legacy PL/SQL web app to modern technologies.",
    ],
    location: "Chennai, India",
    duration: "Jul 2015 - Jun 2017",
    techStack: "JAVA 7, JSF 2.0, SPRING 4.0, JPA, Angular, Prime Faces, HTML 5, CSS 3, LESS, Fusion Charts and many other libraries."
  }
]

export const skills = [
  {
    name: "Java",
    level: 90
  },
  {
    name: "Kotlin",
    level: 65
  },
  {
    name: "Spring Framework",
    level: 85
  },
  {
    name: "J2EE (JSF 2.0+)",
    level: 70
  },
  {
    name: "Java Script / Typescript",
    level: 75
  },
  {
    name: "HTML 5",
    level: 80
  },
  {
    name: "CSS 3",
    level: 70
  },
  {
    name: "React.js",
    level: 85
  },
  {
    name: "Ant Design",
    level: 65
  },
  {
    name: "Angular (2+)",
    level: 55
  },
  {
    name: "PostgreSQL",
    level: 85
  },
  {
    name: "Elastic Search",
    level: 80
  },
  {
    name: "Docker",
    level: 80
  },
  {
    name: "Kubernetes",
    level: 85
  },
  {
    name: "Terraform",
    level: 70
  },
  {
    name: "Jenkins",
    level: 65
  },
  {
    name: "AWS (S3, Fargate, EKS, SNS, SQS, DynamoDB, Lambda)",
    level: 65
  },
]